var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "border-normal",
      class: { "not-allowed": !_vm.hasAuth },
      on: { click: _vm.toDetail },
    },
    [
      _vm.numMiddle
        ? [
            _c(
              "div",
              { staticClass: "card-icon" },
              [
                _c("svg-icon", {
                  attrs: {
                    "icon-name": _vm.iconName,
                    size: "32",
                    iconColor: _vm.iconColor,
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "item-number" }, [
              _vm._v(_vm._s(_vm.itemNumber)),
            ]),
            _c("div", { staticClass: "item-name" }, [
              _vm._v(_vm._s(_vm.itemName)),
            ]),
          ]
        : [
            _c("div", { staticClass: "flex item-center" }, [
              _c(
                "div",
                { staticClass: "card-icon mr-20" },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-name": _vm.iconName,
                      size: "32",
                      iconColor: _vm.iconColor,
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "item-name" }, [
                _vm._v(_vm._s(_vm.itemName)),
              ]),
            ]),
            _c("div", { staticClass: "item-number" }, [
              _vm._v(_vm._s(_vm.itemNumber)),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }